import get from 'lodash/get.js';
import PendoLoading from '../../directives/loading/pendo-loading.js';
import PendoDivider from '../divider/pendo-divider.vue.js';
import PendoTooltip from '../../directives/tooltip/pendo-tooltip.js';
import PendoIconButton from '../icon-button/pendo-icon-button.vue.js';

var script = {
  name: 'TableTitle',
  components: {
    PendoIconButton,
    PendoDivider
  },
  directives: {
    PendoTooltip,
    PendoLoading
  },
  inject: ['$table'],
  computed: {
    showClearSelectedAction() {
      if (this.$table.checkboxConfig.selectAll === false) {
        return this.$table.isIndeterminate || this.$table.isAllSelected;
      }
      return false;
    },
    activeCountText() {
      let availableCount;
      const isRowGroupingEnabled = get(this.$table, 'groupConfig.enabled', false);
      if (isRowGroupingEnabled) {
        availableCount = this.$table.tableData.filter(row => row && row.isGroup).reduce((acc, row) => {
          if (row.children) {
            acc += row.children.length;
          }
          return acc;
        }, 0);
      } else {
        availableCount = this.$table.tableData.filter(row => row && !row.isGroup).length;
      }
      if (this.$table.isIndeterminate || this.$table.isAllSelected) {
        const selectedCount = this.$table.getSelectedRows().length;
        return `(${selectedCount} of ${availableCount} Selected)`;
      }
      return `(${availableCount})`;
    },
    manageColumnsTooltip() {
      return this.$table.manageColumnsConfig.title || 'Manage columns';
    }
  }
};

export { script as default };
//# sourceMappingURL=table-title.vue2.js.map
